module.exports = __webpack_public_path__ + "img/logo.8e3a95dd.png";